module.exports = __webpack_public_path__ + "img/فرهنگی.fd0a9650.jpg";